import { Database } from "@/integrations/supabase/types";

export type BudgetCompatibility = Database["public"]["Enums"]["budget_compatibility_type"];

export type ReviewStatus = 'pending' | 'in_review' | 'evaluated';

export const REVIEW_STATUS_LABELS: Record<ReviewStatus, string> = {
  pending: 'Pendente',
  in_review: 'Em Revisão',
  evaluated: 'Avaliado',
};

export interface EvaluationGroup {
  id: number;
  name: string;
  description: string | null;
  evaluator_id: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  form_id: number;
  areas: string[] | null;
}

export interface EvaluationGroupProgress {
  group_id: number;
  group_name: string;
  group_description: string | null;
  evaluator_id: string;
  evaluator_email: string | null;
  evaluator_name: string | null;
  is_active: boolean;
  created_at: string;
  total_freelancers: number;
  freelancers_evaluated: number;
  freelancers_in_review: number;
  freelancers_pending: number;
  progress_percentage: number;
  form_id: number;
  form_name: string | null;
  areas: string[] | null;
}

export interface EvaluationGroupFreelancer {
  id: number;
  group_id: number;
  group_name: string;
  group_evaluator_id: string;
  freelancer_id: string;
  freelancer_name: string;
  freelancer_email: string;
  added_at: string;
  added_by: string | null;
  is_evaluated: boolean;
  is_in_review: boolean;
  review_status: ReviewStatus;
  evaluated_by: string | null;
  evaluated_at: string | null;
  in_review_at: string | null;
  in_review_by: string | null;
  in_review_reason: string | null;
  evaluator_weight: number | null;
  premios: number | null;
  craft: number | null;
  ideia: number | null;
  resolvedor: number | null;
  versatilidade: number | null;
  desformato: number | null;
  pegada_social: number | null;
  pegada_classica: number | null;
  compativel_grana: BudgetCompatibility | null;
  nota_criterio_pessoal: number | null;
  agencias_afins: string[] | null;
  series_agencias: string[] | null;
  outras_percepcoes: string | null;
  updated_at: string;
  areas: string[] | null;
  pretensao_salarial: string | null;
  portfolio_url: string | null;
  linkedin_url: string | null;
  tempo_experiencia: string | null;
  tipo_atuacao: string | null;
  idiomas: string[] | null;
  historia_profissional: string | null;
  experiencias_anteriores: string | null;
  objetivos: string | null;
  is_active: boolean | null;

  // Campos do freelancer
  telefone?: string | null;
  cidade?: string | null;
}

export const EVALUATION_CRITERIA = [
  { key: "premios", label: "Prêmios" },
  { key: "craft", label: "Craft" },
  { key: "ideia", label: "Ideia" },
  { key: "resolvedor", label: "Resolvedor" },
  { key: "versatilidade", label: "Versatilidade" },
  { key: "desformato", label: "Desformato" },
  { key: "pegada_social", label: "Pegada Social" },
  { key: "pegada_classica", label: "Pegada Clássica" },
] as const;

export const BUDGET_COMPATIBILITY_LABELS: Record<BudgetCompatibility, string> = {
  menos: "Abaixo da média",
  neutro: "Na média",
  mais: "Acima da média",
};

// Constante com as opções de portes de agências
export const PORTES_AGENCIAS_OPTIONS = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
  { value: "E", label: "E" },
] as const;

export type PorteAgencia = typeof PORTES_AGENCIAS_OPTIONS[number]["value"];

